<template>
  <el-table-column
    label="Nettó forgalom"
  >
    <el-table-column
      prop="net_sum"
      label="Egyéni"
      show-overflow-tooltip
      fixed="right"
      min-width="130"
    >
      <template slot-scope="scope">
        {{ scope.row.net_sum | currency('HUF') }}<br>
        <el-tag
          size="mini"
          type="primary"
        >
          {{ scope.row.percent.toFixed(2) }} %
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      prop="net_sum"
      label="Görgetett"
      show-overflow-tooltip
      fixed="right"
      min-width="130"
    >
      <template slot-scope="scope">
        {{ scope.row.net_sum_rolling | currency('HUF') }}<br>
        <el-tag
          size="mini"
          :type="scope.row.percent_rolling <= 80 ? 'success' : 'primary'"
        >
          {{ scope.row.percent_rolling.toFixed(2) }} %
        </el-tag>
      </template>
    </el-table-column>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'net_price',
  };
</script>
